import { CAPABILITIES } from '../data/heroCapabilities';

/* The chip row lives in React (Hero.jsx); the live feed is painted by
   useHeroSimulation with plain DOM, because it choreographs packets flying
   between three panes and React would fight it. This tiny store is the one
   place they agree on which capability is showing.

   Deliberately not context: the simulation isn't a component, so it can't
   consume one. */

let current = CAPABILITIES[0].id;
const subscribers = new Set();

export function getCapability() {
  return current;
}

export function setCapability(id) {
  if (!id || id === current) return;
  current = id;
  subscribers.forEach((fn) => {
    try {
      fn(id);
    } catch {
      /* one bad subscriber must not stop the others */
    }
  });
}

export function subscribeCapability(fn) {
  subscribers.add(fn);
  return () => subscribers.delete(fn);
}
